import React, { useEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { UserMockImage } from "../core/path/images";

const ViewCustomerProfileAdmin = ({ isOpen, onClose, userDetails }) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    setUser(userDetails);
  }, [userDetails]);

  useEffect(() => {
    const modal = document.getElementById("view-customer-modal");
    if (isOpen) {
      modal.showModal();
    } else if (modal.open) {
      modal.close();
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  const handleESC = (event) => {
    event.preventDefault();
    handleClose();
  }



  useEffect(() => {

  }, []);



  return (
    <dialog id="view-customer-modal" className="modal backdrop:bg-[#091E428A]" onCancel={handleESC}>
      <div className="relative col-start-1 row-start-1 max-h-[calc(100vh-5em)] w-11/12 max-w-lg overflow-y-auto rounded-md bg-white text-ink shadow-overlay">

        <div className="modal-content">

        <button
          type="button"
          aria-label="Sluiten"
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded text-ink-subtlest hover:bg-[#091E420F]"
          onClick={handleClose}
        >
          <FeatherIcon icon="x" size={16} />
        </button>
        <h1 className="modal-title px-6 pt-6 text-xl font-medium text-ink">
          Klant Informatie
        </h1>

        <div className="flex flex-col items-center justify-center gap-5 px-6 pt-4">
          <div className="profile-pic">
            <img className="h-20 w-20 rounded-full object-cover" src={user?.profielFoto || UserMockImage} alt="" />
          </div>
        </div>

        <form
          className="update-profile-form !mt-0 px-6 pb-6 pt-4"
          
        >
          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Naam</label>
             <p className="text-sm text-ink">
                {user?.naam || 'N/A'}
               </p>
            </div>

            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Bedrijfsnaam</label>
                <p className="text-sm text-ink">
                {user?.bedrijfsnaam || 'N/A'}
               </p>
            </div>
          </div>

          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Telefoonnummer</label>
              <p className="text-sm text-ink">
                {user?.telefoonnummer || 'N/A'}
               </p>         
            </div>

            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Email</label>
               <p className="text-sm text-ink">
                {user?.email}
               </p>   
            </div>
          </div>

          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Postcode</label>
              <p className="text-sm text-ink">
                {user?.postcode || 'N/A'}
               </p>   
              
            </div>

            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Plaats</label>
              <p className="text-sm text-ink">
                {user?.plaats || 'N/A'}
               </p> 
             
            </div>
          </div>

          <div className="mt-3 grid grid-cols-1 gap-x-6 gap-y-3 md:grid-cols-2">
            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Bedrag</label>
              <p className="text-sm text-ink">
              € {user?.applicationFee || 'N/A'}
             </p>   
              
            </div>

            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Aangemaakt op</label>
              <p className="text-sm text-ink">
                {
                   new Date(user?.createdAt).toLocaleDateString() || 'N/A'
                }
             </p> 
             
            </div>
          </div>
          
            <div className="mt-3"> 
            <div>
              <label className="mb-0.5 block text-xs font-semibold text-ink-subtlest">Adres</label>
               <p className="text-sm text-ink">
                {user?.adres || 'N/A'}
               </p>   
            </div>
            </div>
        
        </form>
        </div>
      </div>
    </dialog>
  );
};

export default ViewCustomerProfileAdmin;
